module.exports = __webpack_public_path__ + "svg/brush.svg?97f37ba9fc82fc00415e9d71f50084a8";